import * as React from "react";
import { forwardRef } from "react";
const SvgWarningTriangule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", {
	width: 24,
	height: 24,
	rx: 4,
	fill: "#F3AF00"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 9.60278V13.343",
	stroke: "#694C00",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 17.7067C12.3825 17.7067 12.6926 17.4276 12.6926 17.0833C12.6926 16.7391 12.3825 16.46 12 16.46C11.6175 16.46 11.3074 16.7391 11.3074 17.0833C11.3074 17.4276 11.6175 17.7067 12 17.7067Z",
	stroke: "#694C00",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.2329 4.67827C13.1166 4.47406 12.94 4.30267 12.7225 4.183C12.505 4.06332 12.255 4 12 4C11.745 4 11.495 4.06332 11.2775 4.183C11.06 4.30267 10.8834 4.47406 10.7671 4.67827L3.14819 18.3923C3.04192 18.5821 2.99133 18.7932 3.00121 19.0056C3.0111 19.2179 3.08113 19.4244 3.20465 19.6056C3.32818 19.7867 3.5011 19.9364 3.707 20.0405C3.9129 20.1445 4.14493 20.1995 4.38107 20.2001H19.6189C19.8551 20.1995 20.0871 20.1445 20.293 20.0405C20.4989 19.9364 20.6718 19.7867 20.7953 19.6056C20.9189 19.4244 20.9889 19.2179 20.9988 19.0056C21.0087 18.7932 20.9581 18.5821 20.8518 18.3923L13.2329 4.67827Z",
	stroke: "#694C00",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgWarningTriangule);
export default ForwardRef;
